module.exports = __webpack_public_path__ + "static/media/case3.0de988e8.png";